import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class StationRevision extends Model<Schemas['stationRevisions'], Models> {}

export type MarkingChecklistItem = StationRevision['markingChecklist'][number];
